



























































































import Vue from "vue";
import {
  VueTableRequest,
  AccountManagementApi,
  UpdatePharmacistCommand
} from "@/api";
import stateMixin from "@/mixins/state";

export default Vue.extend({
  data() {
    return {
      isManager: this.$store.state.auth.auth.userInfo.isManager,
      data: {},
      headers: [
        { text: "#", value: "accountId" },
        { text: "E-mailadres", value: "emailAddress" },
        { text: "Naam", value: "firstName" },
        { text: "Type", value: "pharmacistType" },
        { text: "Actief", value: "isDisabled" },
        { text: "Acties", sortable: false, value: "actions" }
      ],
      options: {
        sortBy: ["accountId"],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 10
      }
    };
  },
  name: "PharmacistsList",
  mixins: [stateMixin],
  methods: {
    async saveItem(item: UpdatePharmacistCommand): Promise<void> {
      this.setState(this.states.INITIAL);
      try {
        const api = new AccountManagementApi();
        await api.accountManagementUpdatePharmacistAccount(item);
        this.setState(this.states.SUCCESSUPDATE);
      } catch (e) {
        this.setState(this.states.ERRORUPDATE);
        setTimeout(() => {
          this.fetch();
        }, 2000);
      }
    },
    fetch: async function() {
      this.setState(this.states.LOADING);
      const api = new AccountManagementApi();
      try {
        const request: VueTableRequest = {
          sortBy: this.options.sortBy,
          descending: this.options.sortDesc,
          page: this.options.page,
          rowsPerPage: this.options.itemsPerPage
        };
        const { data } = await api.accountManagementGetPharmacistsTable(
          request
        );
        this.data = data;
        this.setState(this.states.INITIAL);
      } catch {
        this.setState(this.states.ERRORLOADING);
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.fetch();
      },
      deep: true,
      immediate: false
    }
  }
});
